


   <p-dropdown
   [options]="postingOptions"
   [(ngModel)]="selectedPosting"
   optionLabel="label"
   placeholder="Select Posting Period"
   appendTo="body"
   [disabled]="isViewMode"
   [ngModelOptions]="{ standalone: true }"
   (onChange)="onPostingMonthChange()"
   [ngClass]="(compactDropdownModules.includes(moduleName) && !compactDropdown) ? 'small inlineDD' : 'posting-period-dropdown'"
 >
<ng-template let-selectedOption pTemplate="selectedItem">
  <div [ngStyle]="selectedOption?.isManual ? { color: '#D32F2F' } : {}">
    {{ selectedOption?.label }}
  </div>
</ng-template>
</p-dropdown>
